// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__I3JId","obliqueLineWrap":"membershipbadge_obliqueLineWrap__3Cv7d","obliqueLine":"membershipbadge_obliqueLine__mq7YU"};